import { useMutation } from "@tanstack/react-query";
import { viewContent } from "../../../core/queries/accessControl";
import { useMaterialStore } from "../stores/materialStore";
import { IMaterial } from "../../../core/models/disciplines";

const useMaterialAccessControl = (slug: string) => {
  const { allMaterials } = useMaterialStore();
  const material = allMaterials.find((material: IMaterial) => material.slug === slug);

  const { mutate, isPending, isError, error, isSuccess } = useMutation({
    mutationKey: ['materialAccessControl'],
    mutationFn: () => viewContent(material.slug, material.id, 'workbook'),
  })

  return { mutate, isPending, isError, error, isSuccess };
}

export { useMaterialAccessControl };
